import { FC } from 'react';
import { Text } from '@mofid-securities/uikit';
import BottomSheet from '@/components/BottomSheet';
import Button from '@/components/Button';
import { Divider } from '@/components/Divider';
import { TRedirectData } from '../../types';

interface IEditSejamInfoBottomsheetProps {
  currentStepPayload: TRedirectData;
}

const EditSejamInfoBottomsheet: FC<IEditSejamInfoBottomsheetProps> = ({
  currentStepPayload,
}) => {
  const handleEditSejam = () => {
    BottomSheet.close();
    const link = currentStepPayload?.message?.link;

    // Since we need the link to open it in a new tab, we can't use next router
    if (link) window.open(link, '_blank');
  };

  return (
    <div className="flex flex-col gap-y-4">
      <Text color="gray-120" size="sm" weight="regular">
        {currentStepPayload?.message?.message}
      </Text>
      <Divider />
      <div className="flex flex-col gap-y-2 md:flex-row md:gap-x-2">
        <Button
          className="w-full md:w-1/2"
          isFullWidth
          onClick={handleEditSejam}
        >
          ویرایش اطلاعات سجام
        </Button>
      </div>
    </div>
  );
};

export const openEditSejamInfoBottomsheet = (
  editSejamInfoBottomSheetProps: TRedirectData
) => {
  return BottomSheet.open({
    children: (
      <EditSejamInfoBottomsheet
        currentStepPayload={editSejamInfoBottomSheetProps}
      />
    ),
  });
};
